import { createClient } from '@supabase/supabase-js';

// for local setup:

//const supabaseUrl = "https://nogkwqjwyanppphdeoum.supabase.co";
//const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5vZ2t3cWp3eWFucHBwaGRlb3VtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0Nzc3NTEsImV4cCI6MjA5MzA1Mzc1MX0.BRp_XcyADgdYMSehod_dBio5tS4xR0w-Xqi0DqH7O1o";

//for server setup  
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);